export default __webpack_public_path__ + "static/media/quizzes-empty-state.bd5e317e.svg";